import { Flex } from '@sequencehq/core-components'
import { CSSProperties, FC } from 'react'

import { ApproverItem } from './ApproverItem'

export const ApproversList: FC<{
  approvers: Array<{ id: string; email: string }>
  onDelete: (userId: string) => void
  'data-testid'?: string
  alignItems?: CSSProperties['alignItems']
}> = ({
  approvers,
  onDelete,
  'data-testid': dataTestId,
  alignItems = 'flex-start'
}) => {
  return (
    <Flex
      flexDir="column"
      data-testid={dataTestId}
      gap="8px"
      alignItems={alignItems}
    >
      {approvers.map(({ id, email }) => {
        return (
          <ApproverItem
            key={id}
            email={email}
            onDelete={() => onDelete(id)}
            data-testid={
              dataTestId ? `${dataTestId}.approver.${id}` : undefined
            }
          />
        )
      })}
    </Flex>
  )
}
